import { axiosInstance } from '@/utils/axiosInstance';
import {
  IApplySortRequest,
  IBuyOfferResponse,
  IFilterAndSortResponse,
  IGetOfferByIdRequest,
  IGetOfferByIdResponse,
  IMatchResponse,
  IOffer,
  IOffersMatchRequest,
  IOffersRequest,
  IOffersResponse,
  IReadOffersRequest,
} from './interfaces/offers.interfaces';

export const OffersService = {
  getOffers: async ({
    offset = 0,
    limit = 30,
    authToken,
    radius,
    sort,
    filters,
  }: IOffersRequest): Promise<IOffersResponse> => {
    const body = {
      filters: {
        categories_slugs: [],
        radius: radius,
        only: [],
      },
      sort: sort,
    };

    const getOffers = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
        Authorization: authToken,
      },
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BACKEND_FOR_FRONTEND_URL}/offers/search?offset=${offset}&limit=${limit}`,
      data: {
        sort: body.sort,
        filters: filters ? filters : body.filters,
      },
    };

    const res = await axiosInstance(getOffers);

    return res.data as IOffersResponse;
  },

  getMatchOffers: async ({
    profileId,
    limit = 50,
  }: IOffersMatchRequest): Promise<IOffer[]> => {
    const getOffers = {
      headers: {
        accept: '*/*',
      },
      method: 'GET',
      url: `https://matchmaking-service-654142862275.us-central1.run.app/api/v1/matching/requests?profileId=${profileId}&limit=${limit}`,
    };

    const res = await axiosInstance(getOffers);

    return res.data;
  },

  readOffers: async ({
    offerId,
    authToken,
  }: IReadOffersRequest): Promise<void> => {
    const readOffers = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
        Authorization: authToken,
      },
      method: 'PUT',
      url: `${process.env.NEXT_PUBLIC_BACKEND_FOR_FRONTEND_URL}/offers/${offerId}/read`,
    };

    await axiosInstance(readOffers);
  },

  getOfferById: async ({
    offerId,
    authToken,
  }: IGetOfferByIdRequest): Promise<IGetOfferByIdResponse> => {
    const getOrderById = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
        Authorization: authToken,
      },
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BACKEND_FOR_FRONTEND_URL}/v2/offers/${offerId}`,
    };

    const res = await axiosInstance(getOrderById);

    return res.data;
  },

  getFiltersAndSort: async (
    authToken: string
  ): Promise<IFilterAndSortResponse> => {
    const getFiltersAndSort = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
        Authorization: authToken,
      },
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BACKEND_FOR_FRONTEND_URL}/offers/filters_and_sort`,
    };

    const res = await axiosInstance(getFiltersAndSort);

    return res.data;
  },

  applySort: async ({
    sort,
    authToken,
    filters,
    offset = 0,
  }: IApplySortRequest): Promise<IOffersResponse> => {
    const applySort = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
        Authorization: authToken,
      },
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BACKEND_FOR_FRONTEND_URL}/offers/search?offset=${offset}`,
      data: {
        sort,
        filters,
      },
    };

    const res = await axiosInstance(applySort);

    return res.data;
  },

  buyOffer: async ({
    authToken,
    requestId,
  }: {
    authToken: string;
    requestId: string;
  }): Promise<IBuyOfferResponse> => {
    const buyOffer = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
        Authorization: authToken,
      },
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BACKEND_FOR_FRONTEND_URL}/offers/${requestId}/accept`,
    };

    const res = await axiosInstance(buyOffer);

    return res.data;
  },

  buyOfferWithExclusivity: async ({
    authToken,
    requestId,
  }: {
    authToken: string;
    requestId: string;
  }): Promise<IBuyOfferResponse> => {
    const buyOfferWithExclusivity = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
        Authorization: authToken,
      },
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BACKEND_FOR_FRONTEND_URL}/offers/${requestId}/accept_exclusive_lead`,
    };

    const res = await axiosInstance(buyOfferWithExclusivity);

    return res.data;
  },
};
